import { createRoute, useParams, useSearch } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { appRoute } from "./route";
import { ShoppingListDetail } from "@/features/shopping/components/shopping-list-detail";
import { PageContainer } from "@/components/ui/page-container";

interface ShoppingDetailSearch {
  /** Abre el diálogo "compartir lista" (`?share=1`). */
  share?: boolean;
}

function ShoppingListDetailPage() {
  const params = useParams({ from: "/u/$u/shopping/$listId" });
  const search = useSearch({ from: "/u/$u/shopping/$listId" });
  const navigate = useNavigate();

  // El diálogo "compartir" es deep-linkable (`?share=1`): la URL es la fuente de
  // verdad para abrir/cerrar. `replace` evita inflar el historial.
  const setShareOpen = (open: boolean): void => {
    if (open === Boolean(search().share)) {
      return;
    }
    void navigate({
      to: "/shopping/$listId",
      params: { listId: params().listId },
      search: open ? { share: true } : {},
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="3xl">
      <ShoppingListDetail
        listId={params().listId}
        shareOpen={Boolean(search().share)}
        onShareOpenChange={setShareOpen}
      />
    </PageContainer>
  );
}

export const shoppingListDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/shopping/$listId",
  validateSearch: (search: Record<string, unknown>): ShoppingDetailSearch => ({
    // Incluye el NÚMERO 1: TanStack auto-parsea `?share=1` a number 1 (no string);
    // sin este caso el param se descartaba en el boot y el overlay de compartir
    // no abría por deep-link (CC-18).
    share:
      search.share === true || search.share === 1 || search.share === "1" || search.share === "true"
        ? true
        : undefined,
  }),
  component: ShoppingListDetailPage,
});
